/* eslint-disable */
import React, { useContext } from "react";
import { Modal, Button, Table, Image } from "react-bootstrap";
import Logo from "../../assets/img/logo.svg";
import { useSelector, useDispatch } from "react-redux";
import { GetOrderReportDetails } from "../../redux/actions/adminActions";
import CommonDateTime from "./CommonDateTime";
import AmountNumberFormat from "./AmountNumberFormat";
import OrderDraftRenewOrProceedAPI from "../../Api/OrderDraftRenewOrProceedAPI";
import { toast } from "react-toastify";
import BrowserUniqueTabID from "./BrowserUniqueTabID";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";

const OrderDetailsViewer = (props) => {
  const { OrderViewerModal, setOrderViewerModal, APIcalling, EditAccess, setLoader } = props;
  const { websocket } = useContext(WebSocketContext);

  const { OrderReportDetails, accessToken, device_id } = useSelector(
    (state) => state.adminReducers
  );
  var tabID = BrowserUniqueTabID();
  const Dispatch = useDispatch();

  // close modal
  const handleClose = () => {
    setOrderViewerModal({ ...OrderViewerModal, open: false });
    Dispatch(GetOrderReportDetails({}));
  };

  var originalContents = document.body.innerHTML;
  // common function
  const CommonFunction = async (id) => {
    // const printContents = document.getElementById(id).innerHTML;
    // const originalContents = document.body.innerHTML;
    // document.body.innerHTML = printContents;
    // window.print();
    // document.body.innerHTML = originalContents;
    const printContent = document.getElementById(id);
    const newWindow = window.open("", "_blank", "width=1200,height=600");
    newWindow.document.write(`
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>New Window</title>
            <!-- Add Bootstrap CSS link -->
            <style>
                table.printTable {
                    border-collapse: collapse;
                }
                .printTable th, .printTable td {
                    border: 1px solid black;
                    padding: 8px;
                    text-align: left;
                }
                .printTable th {
                    background-color: #f2f2f2;
                }
            </style>
        </head>
        <body>
            ${printContent.innerHTML}
        </body>
        </html>`);
    newWindow.document.close();
    newWindow.print();

    // Listen for the print dialog close event
    const printDialogClosed = () => {
      newWindow.close();
      window.removeEventListener("focus", printDialogClosed);
    };

    // Event listener to handle print dialog close
    window.addEventListener("focus", printDialogClosed);
  };

  // get total balance and Credit Limit sub_total
  const GetCurrentOrderRate = (current) => {
    let total_gst = 0;
    let price = 0;
    let sub_total = 0;

    // if(current?.is_demo) {
    //     price = parseInt(current?.product?.demo_rate);
    // } else {
    //     price = parseInt(current?.product?.franchise_rate);
    // };
    // let gst_rate = current?.product.igst_rate
    // sub_total = parseInt(parseInt(price) * parseInt(current?.qty) * 100);
    // total_gst = parseInt(total_gst + (parseInt(parseInt(gst_rate) * sub_total)));
    // return {
    //     price: price,
    //     tax: sub_total - total_gst,
    //     total_gst: total_gst,
    //     sub_total: sub_total,
    // };
  };

  // total table count
  const TotalTableCount = (list, url) => {
    if (list?.length > 0) {
      if (url === "qty") {
        let sum = 0;
        for (let i = 0; i < list.length; i++) {
          sum += parseInt(list[i]?.qty);
        }
        return sum;
      } else if (url === "partial_qty") {
        let sum = 0;
        for (let i = 0; i < list.length; i++) {
          sum += parseInt(list[i]?.partial_qty);
        }
        return sum;
      } else if (url === "TaxableAmount") {
        let sum = 0;
        for (let i = 0; i < list.length; i++) {
          sum += parseFloat(list[i]?.sub_total - list[i]?.sub_gst);
        }
        return sum;
      } else if (url === "sub_gst") {
        let sum = 0;
        for (let i = 0; i < list.length; i++) {
          sum += parseFloat(list[i]?.sub_gst);
        }
        return sum;
      } else if (url === "sub_total") {
        let sum = 0;
        for (let i = 0; i < list.length; i++) {
          sum += parseInt(list[i]?.sub_total);
        }
        return sum;
      }
    } else {
      return 0;
    }
  };

  const OrderDraftRenew = async (data) => {
    try {
      setLoader(true)
      let payload = {
        order_id: data.id,
        action: "renew",
      };

      const response = await OrderDraftRenewOrProceedAPI(payload, accessToken);

      if (response.status !== 200) {
        setLoader(false)
        toast.error(response.message);
      } else {
        setLoader(false)
        toast.info(response.message);
        OrderViewerModal.open = false;
        if (APIcalling) APIcalling();
      }
    } catch (error) {
      setLoader(false)
      toast.error("Error sending order to renew stage", error.message);
    }
  };

  const OrderDraftProceed = async (data) => {
    try {
      setLoader(true)
      let payload = {
        order_id: data.id,
        action: "proceed",
      };

      const response = await OrderDraftRenewOrProceedAPI(payload, accessToken);

      if (response.status !== 200) {
        setLoader(false)
        toast.error(response.message);
      } else {
        setLoader(false)
        toast.info(response.message);
        OrderViewerModal.open = false;

        if (APIcalling) APIcalling();
      }
    } catch (error) {
      setLoader(false)
      toast.error("Error sending order to renew stage", error.message);
    }
  };

  const OrderDraftReject = async (data) => {
    const param = {
      transmit: "broadcast",
      url: "order_cancelled",
      request: {
        order_id: data.id,
        cancel_reason: "rejected from franchise draft orders",
        order_status: "REJECTED",
      },
      DeviceId: device_id,
      TabId: tabID,
    };
    wsSend_request(websocket, param);
    OrderViewerModal.open = false;

    if (APIcalling) APIcalling();
  };

  const isBetween25And31IST = () => {
    const now = new Date();

    // Convert current time to IST
    const istTime = new Date(
      now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
    );

    const day = istTime.getDate();
    return day >= 25 && day <= 31;
  };

  return (
    <Modal
      className="OrderDetailsModal"
      id="OrderDetailsModalNew"
      show={OrderViewerModal?.open}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ width: "100%" }}>
          {OrderViewerModal?.Title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="orderDetailsViewr" id="contentToPrint">
        {OrderReportDetails !== undefined &&
        Object.keys(OrderReportDetails)?.length > 0 ? (
          <div>
            <Table style={{ marginBottom: "0px" }}>
              <tbody>
                <tr>
                  <td style={{ padding: "0px" }}>
                    <Image
                      src={
                        "data:image/svg+xml;base64,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"
                      }
                      alt={"Logo"}
                      className="h-auto"
                      width="120px"
                    />
                  </td>
                  <td style={{ padding: "0px", textAlign: "center" }}>
                    <Table>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              padding: "0px 0px 5px 0px",
                              borderBottom: "0px",
                              fontSize: "14px",
                              fontWeight: "600",
                            }}
                            colSpan={4}
                          >
                            Bill To -{" "}
                            {OrderReportDetails?.order?.billing?.customer_name}.
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              padding: "0px 0px 5px 0px",
                              borderBottom: "0px",
                              fontSize: "14px",
                            }}
                            colSpan={4}
                          >
                            Address: {OrderReportDetails?.order?.address},{" "}
                            {
                              OrderReportDetails?.order?.billing_pin_data
                                ?.district?.district_name
                            }{" "}
                            -{" "}
                            {
                              OrderReportDetails?.order?.billing_pin_data
                                ?.pin_code?.pin_code
                            }
                            ,{" "}
                            {
                              OrderReportDetails?.order?.billing_pin_data?.state
                                ?.state_name
                            }
                            , India.
                          </td>
                        </tr>
                        <tr>
                          {OrderReportDetails?.order?.address2 !== null && (
                            <td
                              style={{
                                padding: "0px 0px 5px 0px",
                                borderBottom: "0px",
                                fontSize: "14px",
                              }}
                              colSpan={4}
                            >
                              Address 2: {OrderReportDetails?.order?.address2},{" "}
                              {
                                OrderReportDetails?.order?.billing_pin_data
                                  ?.district?.district_name
                              }{" "}
                              -{" "}
                              {
                                OrderReportDetails?.order?.billing_pin_data
                                  ?.pin_code?.pin_code
                              }
                              ,{" "}
                              {
                                OrderReportDetails?.order?.billing_pin_data
                                  ?.state?.state_name
                              }
                              , India.
                            </td>
                          )}
                        </tr>
                        {/* <tr>
                                        <th style={{ padding: "0px 0px 5px 0px", borderBottom: "0px", fontSize: "14px" }} colSpan={4}>INKODOP TECHNOLOGIES PRIVATE LIMITED.</th>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "0px 0px 5px 0px", borderBottom: "0px", fontSize: "14px" }} colSpan={4}>Address:At post Jambe, Taluka Mulshi, 169/2 Sangawade Road, Pune - 411033,Maharashtra, India.</td>
                                    </tr> */}
                        <tr>
                          <th
                            style={{
                              padding: "0px 0px 5px 0px",
                              borderBottom: "0px",
                              fontSize: "14px",
                            }}
                            colSpan={4}
                          >
                            {OrderReportDetails?.order?.customer_name}
                          </th>
                        </tr>
                        <tr>
                          <td
                            style={{
                              padding: "0px 0px 5px 0px",
                              borderBottom: "0px",
                              fontSize: "14px",
                            }}
                            colSpan={4}
                          >
                            Address: {OrderReportDetails?.order?.address},{" "}
                            {OrderReportDetails?.order?.district?.district_name}{" "}
                            - {OrderReportDetails?.order?.pin_code?.pin_code},{" "}
                            {OrderReportDetails?.order?.state?.state_name},
                            India.
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              padding: "0px",
                              borderBottom: "0px",
                              fontSize: "14px",
                            }}
                          >
                            Phone : {OrderReportDetails?.order?.mobile}
                          </td>
                          <td
                            style={{
                              padding: "0px",
                              borderBottom: "0px",
                              fontSize: "14px",
                            }}
                          >
                            EMail ID : {OrderReportDetails?.order?.email}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
                <tr>
                  <th
                    style={{
                      padding: "17px 0px",
                      fontSize: "14px",
                      textAlign: "center",
                    }}
                    colSpan={2}
                  >
                    {/* PURCHASE ORDER */}
                    SALES ORDER
                  </th>
                </tr>
                <tr>
                  <td style={{ padding: "0px", textAlign: "left" }} colSpan={2}>
                    <Table>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              padding: "7px 0px",
                              borderBottom: "0px",
                              fontSize: "14px",
                            }}
                          >
                            Franchise ID :{" "}
                            {OrderReportDetails?.order?.billing?.franchise_code?.replace(
                              "FC",
                              ""
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              padding: "7px 0px",
                              borderBottom: "0px",
                              fontSize: "14px",
                            }}
                          >
                            Order No : {OrderReportDetails?.order?.order_code}
                          </td>
                          <td
                            style={{
                              padding: "7px 0px",
                              borderBottom: "0px",
                              fontSize: "14px",
                            }}
                          >
                            Order Date :{" "}
                            {CommonDateTime(
                              OrderReportDetails?.order?.created_at,
                              "LL",
                              "show"
                            )}
                          </td>
                          <td
                            style={{
                              padding: "7px 0px",
                              borderBottom: "0px",
                              fontSize: "14px",
                            }}
                          >
                            Invoice Date :{" "}
                            {CommonDateTime(
                              OrderReportDetails?.order?.invoice_at,
                              "LL",
                              "show"
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
              </tbody>
            </Table>
            <Table className="printTable" bordered>
              <thead>
                <tr>
                  <th
                    rowSpan="2"
                    style={{ padding: "7px 7px", fontSize: "14px" }}
                  >
                    Sl. No.
                  </th>
                  <th
                    rowSpan="2"
                    style={{ padding: "7px 7px", fontSize: "14px" }}
                  >
                    Product Description{" "}
                  </th>
                  <th
                    rowSpan="2"
                    style={{ padding: "7px 7px", fontSize: "14px" }}
                  >
                    HSN Code
                  </th>
                  <th
                    rowSpan="2"
                    style={{ padding: "7px 7px", fontSize: "14px" }}
                  >
                    UOM
                  </th>
                  <th
                    rowSpan="2"
                    style={{ padding: "7px 7px", fontSize: "14px" }}
                  >
                    Rate
                  </th>
                  {OrderReportDetails.order?.order_status &&
                    (OrderReportDetails.order?.order_status === "DRAFT" ||
                      OrderReportDetails.order.order_status === "RENEW") && (
                      <th
                        rowSpan="2"
                        style={{ padding: "7px 7px", fontSize: "14px" }}
                      >
                        Fulfilled Qty
                      </th>
                    )}
                  <th
                    rowSpan="2"
                    style={{ padding: "7px 7px", fontSize: "14px" }}
                  >
                    Ordered Qty
                  </th>
                  {OrderReportDetails.order?.order_status &&
                    (OrderReportDetails.order?.order_status === "DRAFT" ||
                      OrderReportDetails.order.order_status === "RENEW") && (
                      <th
                        rowSpan="2"
                        style={{ padding: "7px 7px", fontSize: "14px" }}
                      >
                        Pending Qty
                      </th>
                    )}
                  <th
                    rowSpan="2"
                    style={{ padding: "7px 7px", fontSize: "14px" }}
                  >
                    Taxable Amount
                  </th>
                  <th
                    colSpan="2"
                    style={{
                      padding: "7px 7px",
                      fontSize: "14px",
                      textAlign: "center",
                    }}
                  >
                    IGST
                  </th>
                  <th
                    rowSpan="2"
                    style={{ padding: "7px 7px", fontSize: "14px" }}
                  >
                    Total
                  </th>
                </tr>
                <tr>
                  <th>Rate</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {OrderReportDetails?.order_items_list?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {index + 1}
                      </td>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {item?.product_name}
                      </td>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {item?.hsn_code}
                      </td>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {item?.sku_type}
                      </td>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {AmountNumberFormat(item?.price)}
                      </td>
                      {OrderReportDetails.order?.order_status &&
                        (OrderReportDetails.order?.order_status === "DRAFT" ||
                          OrderReportDetails.order.order_status ===
                            "RENEW") && (
                          <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                            {item?.partial_qty}
                          </td>
                        )}
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {item?.qty}
                      </td>
                      {OrderReportDetails.order?.order_status &&
                        (OrderReportDetails.order?.order_status === "DRAFT" ||
                          OrderReportDetails.order.order_status ===
                            "RENEW") && (
                          <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                            {item?.qty - item?.partial_qty}
                          </td>
                        )}
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {parseFloat(item?.sub_total - item?.sub_gst).toFixed(2)}
                      </td>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {item?.gst_rate}%
                      </td>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {item?.sub_gst}
                      </td>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {item?.sub_total}
                      </td>
                    </tr>
                  );
                })}
                <tr className="totaltd border">
                  <th colSpan={4} className="text-center">
                    Grand total
                  </th>
                  <td>-</td>
                  {OrderReportDetails.order?.order_status &&
                    (OrderReportDetails.order?.order_status === "DRAFT" ||
                      OrderReportDetails.order.order_status === "RENEW") && (
                      <td>
                        {TotalTableCount(
                          OrderReportDetails?.order_items_list,
                          "partial_qty"
                        )}
                      </td>
                    )}
                  <td>
                    {TotalTableCount(
                      OrderReportDetails?.order_items_list,
                      "qty"
                    )}
                  </td>
                  {OrderReportDetails.order?.order_status &&
                    (OrderReportDetails.order?.order_status === "DRAFT" ||
                      OrderReportDetails.order.order_status === "RENEW") && (
                      <td>
                        {TotalTableCount(
                          OrderReportDetails?.order_items_list,
                          "qty"
                        ) -
                          TotalTableCount(
                            OrderReportDetails?.order_items_list,
                            "partial_qty"
                          )}
                      </td>
                    )}
                  <td>
                    {AmountNumberFormat(
                      TotalTableCount(
                        OrderReportDetails?.order_items_list,
                        "TaxableAmount"
                      )
                    )}
                  </td>
                  <td>-</td>
                  <td>
                    {AmountNumberFormat(
                      TotalTableCount(
                        OrderReportDetails?.order_items_list,
                        "sub_gst"
                      )
                    )}
                  </td>
                  <td>
                    {AmountNumberFormat(
                      TotalTableCount(
                        OrderReportDetails?.order_items_list,
                        "sub_total"
                      )
                    )}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        ) : (
          <>Please Wait...</>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div
          className={`d-flex ${
            OrderReportDetails.order?.order_status &&
            (OrderReportDetails.order?.order_status === "DRAFT" ||
              OrderReportDetails.order.order_status === "RENEW") && EditAccess
              ? `justify-content-between`
              : `justify-content-end`
          } align-items-center w-100`}
        >
          {OrderReportDetails.order?.order_status &&
            (OrderReportDetails.order?.order_status === "DRAFT" ||
              OrderReportDetails.order.order_status === "RENEW") && EditAccess && (
              <div className="d-flex" style={{ gap: "0.5em" }}>
                <Button
                  variant="outline-success"
                  onClick={() => OrderDraftProceed(OrderReportDetails?.order)}
                >
                  Proceed
                </Button>
                <Button
                  variant={`${isBetween25And31IST() ? "outline-dark" : "dark"}`}
                  disabled={!isBetween25And31IST()}
                  onClick={() => OrderDraftRenew(OrderReportDetails?.order)}
                >
                  Renew
                </Button>
                <Button
                  variant="outline-danger"
                  onClick={() => OrderDraftReject(OrderReportDetails?.order)}
                >
                  Reject
                </Button>
              </div>
            )}
          <div className="d-flex" style={{ gap: "0.5em" }}>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button
              variant="primary"
              className="addbtncmn"
              onClick={() => CommonFunction("contentToPrint")}
            >
              Print
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default OrderDetailsViewer;
